import { UIMatch, useMatches } from 'react-router';
import { RouteHandle } from 'types/ReactRouter';
import { Account } from 'utils/contexts/AuthContext/AuthContextType';
import { noop } from 'lodash';

const zendesk = {
    get sdk() {
        return globalThis.zE || noop;
    },
};

function setHorizontalPosition(position: 'left' | 'right') {
    zendesk.sdk('webWidget', 'updateSettings', {
        webWidget: {
            position: {
                horizontal: position,
            },
        },
    });
}

export const setZendeskUserInfo = (account: Account) => {
    zendesk.sdk('webWidget', 'prefill', {
        name: {
            value: account.full_name,
        },
        email: {
            value: account.email,
        },
    });
};

export const setAppVersionForZendesk = (version: string) => {
    zendesk.sdk('webWidget', 'prefill', {
        version: {
            value: version,
        },
    });
};

export const hideZendeskWidget = () => zendesk.sdk('webWidget', 'hide');
export const showZendeskWidget = () => zendesk.sdk('webWidget', 'show');

export const useZendeskWidget = () => {
    const routeMatches = useMatches() as UIMatch<unknown, RouteHandle>[];
    const zendeskHorizPositionMatch = routeMatches.filter(
        (match) => match.handle?.zendeskHorizPosition
    );
    const pageMandatedHorizPosition =
        zendeskHorizPositionMatch.at(-1)?.handle.zendeskHorizPosition ||
        'right';

    setHorizontalPosition(pageMandatedHorizPosition);

    return {
        setZendeskHorizPosition: (position: 'left' | 'right') => {
            setHorizontalPosition(position);
        },
        resetZendeskHorizPosition: () => {
            setHorizontalPosition(pageMandatedHorizPosition);
        },
    };
};
